import { useLang } from "../../../services/lang";
import { UserVote } from "../../../components/User";
import { Users, PollOption } from "../../../../types";

export function PollOptionDetail({ users, option }: { users: Users, option: PollOption }) {
    const { dict } = useLang();
    const optionUsers = Object.entries(option.users).filter(([, v]) => v).map(([user]) => users[user]);

    return <>
        {option.description && <p>{option.description}</p>}
        {optionUsers.length === 0 && <p className="info">{dict.pollNoVote}</p>}

        {optionUsers.map((user, i) => <UserVote key={i} user={user} />)}
    </>;
}
